module.exports = __webpack_public_path__ + "static/media/infinity-track.6f835c0b.svg";